import type { Owner } from "./pathSteps";
import styles from "./amazonOverview.module.css";

const LABEL: Record<Owner, string> = {
  inrange: "InRange",
  amazon: "Amazon",
  third: "DNO or landlord",
  both: "Both",
};

const CLASS: Record<Owner, string> = {
  inrange: styles.chipInrange,
  amazon: styles.chipAmazon,
  third: styles.chipThird,
  both: styles.chipBoth,
};

/** Who owns a step, in the owner's colour. */
export const PartyChip = ({
  owner,
  label,
}: {
  owner: Owner;
  label?: string;
}) => (
  <span className={`${styles.chip} ${CLASS[owner]}`}>
    {label ?? LABEL[owner]}
  </span>
);
